import angular from 'angular'
import config from 'emun.retailer/retailer.config'
import $appConfig from 'servicestack/config'
import templateUrl from 'emun.consumer/consumer-order-one-up.htm'
import CartController from 'emun.cart/cart.controller'

class OrderOneUpController extends CartController {
    constructor ($cart) {
        super($cart)
        this.hideParcels = (config.hideParcels === true);
        this.productImage = $appConfig.productImage;
    }
}

const OrderOneUp = {
    bindings:{
        order: '<',
    },
    controller: OrderOneUpController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

angular.module('emun.consumer').component('consumerOrderOneUp', OrderOneUp);

export default OrderOneUp;